var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-row"},[_c('div',{staticClass:"stats-range"},[_c('label',[_vm._v("STATS RANGE")]),_c('ul',_vm._l((_vm.options),function(opt){return _c('li',{key:opt,class:{ 'active': _vm.selectedRange === opt },on:{"click":function($event){return _vm.changeDate(opt)}}},[_vm._v(" "+_vm._s(opt)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }